// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__cyrkx","Open":"SideDrawer_Open__3PkuR","Close":"SideDrawer_Close__3iWqY","Logo":"SideDrawer_Logo__2UVEb"};